import React, { useEffect, useState } from "react";
import { createUseStyles } from "react-jss";
import { useLocation, useRouteMatch } from "react-router-dom";
import { inject } from "mobx-react";
import { Container, Row } from "reactstrap/lib";
import { useGetMobileTagsQuery, useFiltersTariffs } from "routes/operator/routes/hooks";
import { ResetFiltersBlock } from "designSystem/EmptyContentBlocks/ResetFiltersBlock/ResetFiltersBlock";
import { OPERATOR_TAB_ACTIONS } from "stores/OperatorModel";
import { isMainSiteCode } from "Utils/siteConfig";
import Metrika from "Services/Metrika";
import { ReviewListContainerV3 } from "Containers/Review";
import { YANDEX_TARGETS } from "Constants/metriks/yandex-targets";
import TagButtonComponent from "Containers/TagButtonComponent";
import { PaddingBottom, PaddingTop } from "ComponentsUI/Spacings";
import MobileTariffList from "ComponentsUI/MobileTariffList";
import { BlockReviews } from "ComponentsUI/Blocks";
import TariffsFilterContainer from "../ratesMobile/Containers/TariffsFilterContainer";
import FILTER_TYPES from "./FILTER_TYPES";

const useStyles = createUseStyles((theme) => ({
	[`@media (min-width: ${theme.media.md})`]: {
		container: {
			marginTop: "50px",
		},
	},
}));

// const LIMIT = 30;
const MINUTES_RANGE_STEP = 10;

const Actions = (props) => {
	const {
		operatorForCard: {
			info: { cnt_action_tariffs },
		},
		ApplicationModel: { text, operatorModel, mobileFiltersTouchModel },
	} = props;
	const siteCode = props.ApplicationModel.siteCode;
	const classes = useStyles();

	const location = useLocation();

	const { tariffs, currentOperator, resetFilters, setFilters, initalFilters, currentFilters } =
		useFiltersTariffs(location.search, true);

	const [filtersItems, setFiltersItems] = useState(null);
	const selected = filtersItems ? filtersItems.filter((item) => item.props.value) : [];

	useEffect(() => {
		if (operatorModel.visibleTab !== OPERATOR_TAB_ACTIONS) {
			operatorModel.changeTab(OPERATOR_TAB_ACTIONS);
		}
	}, []);

	useEffect(() => {
		if (!initalFilters) {
			return;
		}

		setFiltersItems([
			{
				type: FILTER_TYPES.RANGE,
				props: {
					range: initalFilters.minutes,
					title: text.MINUTES,
					value: currentFilters.minutes,
					changeFilter: (type, value) => {
						setFilters(initalFilters, {
							minutes: value,
						});
					},
					onReset() {
						setFilters(initalFilters, {
							minutes: null,
						});
					},
					step: MINUTES_RANGE_STEP,
					onFocus() {
						mobileFiltersTouchModel.setFocus();
					},
					onBlur() {
						mobileFiltersTouchModel.removeFocus();
					},
					inputNameMin: "change_minutes_min",
					inputNameMax: "change_minutes_max",
				},
			},
			{
				type: FILTER_TYPES.RANGE,
				props: {
					range: initalFilters.gigabytes,
					title: text.INTERNET,
					value: currentFilters.gigabytes,
					changeFilter: (type, value) => {
						setFilters(initalFilters, {
							gigabytes: value,
						});
					},
					onReset() {
						setFilters(initalFilters, {
							gigabytes: null,
						});
					},
					onFocus() {
						mobileFiltersTouchModel.setFocus();
					},
					onBlur() {
						mobileFiltersTouchModel.removeFocus();
					},
					inputNameMin: "change_gb_min",
					inputNameMax: "change_gb_max",
				},
			},
			{
				type: FILTER_TYPES.RANGE,
				props: {
					range: initalFilters.price,
					title: text.SUBSCRIPTION_FEE,
					value: currentFilters.price,
					changeFilter: (type, value) => {
						setFilters(initalFilters, {
							price: value,
						});
					},
					onReset() {
						setFilters(initalFilters, {
							price: null,
						});
					},
					onFocus() {
						mobileFiltersTouchModel.setFocus();
					},
					onBlur() {
						mobileFiltersTouchModel.removeFocus();
					},
					inputNameMin: "change_price_min",
					inputNameMax: "change_price_max",
				},
			},
		]);
	}, [
		currentFilters.gigabytes,
		currentFilters.minutes,
		currentFilters.price,
		initalFilters,
		setFilters,
		text,
		currentOperator,
		mobileFiltersTouchModel,
	]);

	const routeMach = useRouteMatch();

	useEffect(() => {
		Metrika.getInstance().yandex.sendEvent(YANDEX_TARGETS.OPEN_ACTIONS_OPERATORY, []);
	}, [routeMach.path]);

	const { mobileTags } = useGetMobileTagsQuery(!cnt_action_tariffs);

	return (
		<PaddingTop containerClass={classes.container}>
			<PaddingBottom>
				{filtersItems && (
					<TariffsFilterContainer filters={filtersItems} onMobileResetButtonClick={resetFilters} />
				)}
				{isMainSiteCode(siteCode) && <div></div>}
				<Container>
					{tariffs.length ? (
						<PaddingTop>
							<TagButtonComponent
								mobileTags={mobileTags}
								text={text}
								tagCode={true}
								operatorRates={true}
								operatorStyle={true}
							/>
							<Row>
								<MobileTariffList tariffs={tariffs} text={text} isAction={true} />
							</Row>
						</PaddingTop>
					) : null}
					{!tariffs.length && selected.length ? (
						<ResetFiltersBlock text={text} onResetClick={resetFilters} />
					) : null}
				</Container>
			</PaddingBottom>
			<Container>
				<BlockReviews
					reviewLocation="operator_actions"
					queryType="regionFull"
					text={text}
					reviews={
						<ReviewListContainerV3
							text={text}
							reviewLocation="about_operator"
							queryType="reviews"
						/>
					}
				/>
			</Container>
		</PaddingTop>
	);
};

export default inject("ApplicationModel")(Actions);
